<template>
    <v-card>
        <div style="padding: 16px 24px 10px">
            <s-crud 
                @save="save($event)"
                height="auto" 
                remove
                title="Usuarios"
				:filter="filter"
                :config="config"
                searchInput
                close
                @close="$emit('closeUser')"
                ref = "ScrudUsersList"
            >
            <template v-slot:options>
                <v-tooltip bottom >
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" small @click="AddUser()" elevation="0">
                            <v-icon style="font-size:18px;">mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>Asistencia masiva</span>
                </v-tooltip>
            </template>

            </s-crud>

            <v-dialog
			    v-model="dialogUsersAdd"
                width="500"
                persistent
            >
            <v-card>
                <v-container style="padding: 5px 15px 5px 5px;">
                    <s-user v-model="usersCopy" ref="usrcopy" :isCrud="false" :singleRow="false" />
                    <v-row>
                        <v-col>
                            <v-btn color="red" dark depressed small @click="dialogUsersAdd=false">Cancelar</v-btn>
                        </v-col>
                        <v-col align="right">
                            <v-btn color="success" dark depressed small @click="save()">Asignar Usuarios</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            </v-dialog>

        </div>
	</v-card>
</template>

<script>
import _sCheckListUserService from '@/services/Utility/CheckListUserService';
import sToolbarPerson from "@/components/Utils/RecursosHm/sToolbarAgreementPerson";
import sUser from "@/views/Security/UserOption/User.vue";

	export default {
		props: {
			item : {
                type: Object,
                default: () => {}
            },
        },
        components: {
            sToolbarPerson,
            sUser
        },
		data() {
			return {
                filter : {},
                items: [],
                selected: [],
                RtkStatus: false,
                userSelected :{},
                dialogUsersAdd : false,
                usersCopy : [],
                config : {
                    service: _sCheckListUserService,
                    model: {
                        PrsID: "ID",
                    },
                    headers: [
						{text: "ID", value: "PrsID"},
						{text: "Apellidos y Nombres", value: "NtpFullName"}
					]
                },
			};
		},
		methods: {
            returnPerson(value, item) {
                if (value != null) {
                    item.NtpID = value.NtpID;
                    item.PrsID = value.PrsID;
                    item.NtpFullName = value.NtpFullName;
                    console.log(item);
                }
            },
            changeUserSelected(user) {
				if(user.UsrID != undefined)
				{
					this.UsrID = user.UsrID
				}
				this.userSelected = user;
			},
            save(){
                console.log(this.usersCopy);
                let savePromises = [];
                const userID = this.$fun.getUserID();
                this.usersCopy = Object.assign([], this.usersCopy).filter((x) => x.UsrID != "");

                this.$fun.alert("Seguro de Guardar?", "question").then(r => {
                    if (r.value) {

                        this.usersCopy.forEach(item => {
                            item.CktID = this.item.CktID;
                            item.UsrCreateID = userID;
                            item.UsrUpdateID = userID;

                            console.log("Guardando item", item);

                            let savePromise = _sCheckListUserService.save(item, userID);
                            savePromises.push(savePromise);
                        });

                        Promise.all(savePromises)
                            .then(responses => {
                                const allSuccessful = responses.every(resp => resp.status === 200);

                                if (allSuccessful) {
                                    this.$fun.alert("Se agregaron correctamente", "success");
                                    this.dialogUsersAdd = false;
                                    this.$refs.ScrudUsersList.refresh();
                                } else {
                                    this.$fun.alert("Algunas operaciones fallaron", "warning");
                                }
                            });
                    }
                });
            },
            AddUser(){
                this.dialogUsersAdd = true;
            },
            saveT(item){
				item.CktID = this.item.CktID;
				item.UsrCreateID = this.$fun.getUserID();
				item.UsrUpdateID = this.$fun.getUserID();
                console.log("item",item);
                
				this.$fun.alert("Seguro de Guardar?", "question")
				.then(r => {
					if(r.value){
						_sCheckListUserService.save(item, this.$fun.getUserID())
							.then(resp => {
								if(resp.status == 200){
									this.$fun.alert("Se agrego correctamente", "success");
									this.$refs.ScrudUsersList.refresh();
								}
							});
					}
				});
			}
		},
        mounted (){
            this.filter.CktID = this.item.CktID;
        }
	};
</script>